import RmnBottomBanner from 'components/Rmn/RmnBottomBanner/RmnBottomBanner';
import { withRmnBottomBannerProps } from 'viewModel/rmn/rmnBottomBanner/withRmnBottomBannerProps';

const ConnectedRmnBottomBanner = withRmnBottomBannerProps(RmnBottomBanner);

export default ConnectedRmnBottomBanner;
